/**
 * Diretiva responsável por apresentar um endereço eletrônico com prefixo, se apropriado.
 */

angular.module("avlib").directive("avEAddress", function(){
	return {
		template: "{{prefix}}{{eAddress.address}}",
		restrict: "E",
		scope: {
			eAddress: '=',
		},
		controller: ["$scope", function($scope){
			switch ($scope.eAddress.type.id) {
			case 1:
			case 6:
				$scope.prefix = "";
				break;
			default:
				$scope.prefix = "/";
				break;
			}
		}],
	};
});
